import React from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';

import { VideoListContainer } from '../components/video-list/VideoListContainer';

export const VideoListProvider = ({ store, data }) => (
    <Provider store={store}>
        <VideoListContainer {...data} />
    </Provider>
);

VideoListProvider.propTypes = {
    store: PropTypes.object.isRequired,
    data: PropTypes.object
};
